import React from 'react';
import { View, } from 'react-native-web';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { colors, } from './utils/styling';
import Login from './pages/Login';
import AdvisorPortal from './pages/advisor';
import RoutingConfig from './pages/advisor/RoutingConfig';
import MarketingKit from './pages/advisor/MarketingKit';
import Onboarding from './pages/Onboarding';
import ClientView from './pages/advisor/client/[clientId]';
import SignUp from './pages/SignUp';
import SetPassword from './pages/SetPassword';
import MfaVerify from './pages/MfaVerify';
import ForgotPassword from './pages/ForgotPassword';
import { QuizPage } from './pages/quiz';
import ClientPortal from './pages/client';
import ProtectedRoute from './routes/ProtectedRoute';
import QuizHeader from './components/layout/QuizHeader';
import MainHeader from './components/layout/MainHeader'
import ContactSubmit from './pages/quiz/ContactSubmit';
import InfoCollection from './pages/quiz/InfoCollection';
import MainResults from './pages/quiz/MainResults';
import './fonts/fonts.css';
import ConfirmConnect from './pages/quiz/ConfirmConnect';
import SubmitPriorities from './pages/quiz/SubmitPriorities';
import GeneralPersonalityPage from './pages/personalities/GeneralPersonalityPage';
import PersonalityResources from './pages/personalities/PersonalityResources';
import About from './pages/About';
import BookDemo from './pages/public/BookDemo';
import WhoWeServe from './pages/public/WhoWeServe';
import Resources from './pages/public/Resources';
import FAQ from './pages/public/FAQ';
import GetHelp from './pages/public/GetHelp';
import Pricing from './pages/public/Pricing';
import ProfileInfoCollection from './pages/client/ProfileInfoCollection'
import SubscriptionRequired from './pages/SubscriptionRequired';
import './App.css';
import Redirect from './pages/quiz/Redirect';
import Home from './pages/Home';
import AdvisorsHome from './pages/AdvisorsHome';
import ResultsReady from './pages/quiz/ResultsReady';
import UnlockAndSignUp from './pages/quiz/UnlockAndSignUp';
import UnlockAndSignUpTemp from './pages/quiz/UnlockAndSignUpTemp';
import ErrorBoundary from './components/common/ErrorBoundary';

const App: React.FC = () => {
  return (
    <Router>
      <View style={{ flex: 1, backgroundColor: colors.light, position: 'relative', minHeight: '100vh' }}>
        {/* App-wide render-error net (ClickUp 86bb0gg67). Wraps every route so a throw on
            ONE page shows a readable message instead of white-screening the whole app.
            Inside the Router so the fallback's "Retake the quiz" navigation works. */}
        <ErrorBoundary label="routes">
        <Routes>
          {/* Public routes */}
          <Route element={<MainHeader/>}>
            <Route path="/" element={<Home />} />                    {/* Individual front door -> quiz (Nina 2026-09-23 compliance ruling) */}
            <Route path="/advisors" element={<AdvisorsHome />} />    {/* Advisor marketing page; /advisor is the logged-in portal */}
            <Route path="/about" element={<About/>} />
            <Route path="/personalities" element={<GeneralPersonalityPage/>} />
            <Route path="/personalities/:personality" element={<GeneralPersonalityPage/>} />
            <Route path="/personalities/:personality/resources" element={<PersonalityResources/>} />
            {/* Public marketing shells — McKayla 2026-08-20 Looms (F2, F3, F4, F9, F10),
                ClickUp 86bah7dqn. Deliberately NOT in MainHeader's nav yet: these are
                layout templates on a production site that Nina's clients use, so they are
                reachable by direct URL for review and get linked once the copy is real. */}
            <Route path="/demo" element={<BookDemo />} />
            <Route path="/who-we-serve" element={<WhoWeServe />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/help" element={<GetHelp />} />
            <Route path="/pricing" element={<Pricing />} />
            {/* /contact previously rendered the literal string "Contact Page". Get Help is
                the page McKayla actually asked for; the old path redirects rather than
                 404ing, since it may be linked from material we do not control. */}
            <Route path="/contact" element={<Navigate to="/help" replace />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          {/* Advisor-sent onboarding intake (86badfke7). Public — the advisor link
              carries ?advisor=<public_id> for attribution + routing. */}
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/mfa" element={<MfaVerify />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/subscription-required" element={<SubscriptionRequired />} />
          <Route path="/quiz" element={<QuizHeader />}>
            <Route path="results-ready" element={<ResultsReady/>} />
            <Route path="unlock" element={<UnlockAndSignUpTemp />} />
            <Route path="results/submit" element={<ContactSubmit/>} />          {/* Page where user submits contact info before getting main results */}
            <Route path="results/informationform" element={<InfoCollection/>} /> {/* Pre-PDF demographic capture; persists to quizzes.info (MONEY 86babnm61) */}
            <Route path="results/main" element={<MainResults/>} />              {/* Main quiz results page */}
            <Route index element={<QuizPage />} />                              {/* Actual main quiz */}

            <Route path="/quiz/:clientId" element={<QuizPage />} />    

            <Route path="connect/confirm" element={<ConfirmConnect/>} />
            <Route path="connect/submit" element={<SubmitPriorities/>} />

            <Route path="signup" element={<SignUp />} />

            <Route path="redirect" element={<Redirect/>} />
          </Route>            
          {/* Protected routes */}
          <Route path="/advisor" element={<ProtectedRoute><AdvisorPortal /></ProtectedRoute>} />
          <Route path="/advisor/routing" element={<ProtectedRoute><RoutingConfig /></ProtectedRoute>} />
          <Route path="/advisor/marketing" element={<ProtectedRoute><MarketingKit /></ProtectedRoute>} />
          <Route path="/advisor/client/:clientId" element={<ProtectedRoute><ClientView /></ProtectedRoute>} />
          <Route path="/client" element={<ProtectedRoute><ClientPortal /></ProtectedRoute>} />
          <Route path="/client/info-collection" element={<ProtectedRoute><ProfileInfoCollection /></ProtectedRoute>} />
        </Routes>
        </ErrorBoundary>
      </View>
    </Router>
  );
};

export default App; 